import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { createNullOption } from '@cas/components/inputs/dropdown-items/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

enum InterventionControl {
  Disabled = 'Disabled',
  Enabled = 'Enabled',
}

const interventionKeyValues: [InterventionControl, boolean][] = [
  [InterventionControl.Disabled, false],
  [InterventionControl.Enabled, true],
];

export const useInterventionControlOptions = (): DropdownItemProps<boolean | null>[] => {
  const { t } = useTranslation();

  return useMemo(() => {
    const nullOption = createNullOption(t);

    const booleanOptions: DropdownItemProps<boolean>[] = interventionKeyValues.map(
      ([key, value]) => ({
        key,
        value,
        stringValue: key,
        label: t(`InterventionControl.${key}`),
      }),
    );

    return [nullOption, ...booleanOptions];
  }, [t]);
};

export default useInterventionControlOptions;
